import { useState } from "react";
import styles from "./FileInput.module.scss";
import { Icon } from "../Icon";

type FileInputProps = {
  label: string;
  accept: string;
  onChange: (file: File | undefined) => void;
  translations: FileInputTranslations;
  required?: boolean;
};
type FileInputTranslations = {
  fileUploadPlaceholder?: string;
  fileUploadOverlayPlaceholder: string;
};
export function FileInput({
  label,
  accept,
  onChange,
  translations,
  required,
}: FileInputProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const inputId = `${label.replace(/\s+/g, "_")}_INPUT`;

  const handleFileChange = (file?: File) => {
    setSelectedFile(file || null);
    onChange(file || undefined);
  };

  return (
    <div className={styles.fileInputContainer}>
      <label htmlFor={inputId} className={styles.label}>
        {label}
        {required && typeof label === "string" && (
          <>
            <strong aria-hidden>*</strong>
            <span className="sr-only">(required)</span>
          </>
        )}
      </label>

      <div className={styles.dropAreaWrapper}>
        <div
          className={`${styles.dropArea} ${selectedFile ? styles.selectedFile : ""}`}
        >
          <input
            id={inputId}
            className={styles.input}
            type="file"
            accept={accept}
            onClick={(e) => {
              const el = e.currentTarget as HTMLInputElement;
              // Clear the value so the same file can be selected again.
              // Without this, selecting the same file twice in a row will not trigger onChange.
              el.value = ""; 
            }}
            onChange={(e) => handleFileChange(e.target.files?.[0])}
            required={required}
          />

          {!selectedFile && (
            <div className={styles.placeholder}>
              <Icon name="upload_file" />
              {translations.fileUploadPlaceholder || label}
            </div>
          )}

          {selectedFile && (
            <span className={styles.filename}>
              <Icon name="check_circle" />
              {selectedFile.name}
            </span>
          )}

          <div className={styles.uploadOverlay}>
            <Icon name="upload" />
            <span className={styles.text}>
              <strong>{translations.fileUploadOverlayPlaceholder}</strong>
            </span>
            <span>({accept})</span>
          </div>
        </div>
      </div>
    </div>
  );
}
